module.exports = __webpack_public_path__ + "img/pt-hydepark-logo 1.816d3ea9.png";